module.exports = __webpack_public_path__ + "static/media/xuluming.42a59394.png";